<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="flex flex-col border-b border-solid border-gray-200 py-5">
    <button
      class="flex cursor-pointer items-center justify-between text-left"
      :title="itemData.name"
      @click="handleToggle"
    >
      <div
        class="w-full break-words pr-4 font-bold hover:text-blue-400 hover:underline tablet:text-lg desktop:text-xl"
      >
        {{ itemData.name }}
      </div>
      <div class="h-6 w-6 basis-6">
        <IconCaret
          :direction="isShow ? 'up' : 'down'"
          class="h-full w-full text-blue-400"
        />
      </div>
    </button>
    <div v-if="isShow" class="mt-4">
      <div
        class="markdown-content"
        v-html="provideMarkdownHtml(itemData.description, 'simple')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { IProductInfoOverviewFeature } from '@/assets/types/api/Products';

  interface IProps {
    defaultShow: boolean;
    itemData: IProductInfoOverviewFeature;
  }

  const props = withDefaults(defineProps<IProps>(), {
    defaultShow: false,
    itemData: () => ({
      name: '',
      description: '',
    }),
  });

  const isShow = ref<boolean>(props.defaultShow);

  const handleToggle = (): void => {
    isShow.value = !isShow.value;
  };
</script>
